// Hàm format date
/* @param {string} dateString - Chuỗi ngày tháng cần format (ví dụ: "27/11/2025 00:00:00").
 * @returns {string} Chuỗi ngày tháng đã format (DD/MM/YYYY) hoặc chuỗi rỗng.
 */
import dayjs from "dayjs";
// Import plugin CustomParseFormat để Day.js có thể parse định dạng custom của bạn
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import moment from "moment";

export function getFomartDateBefore(dateStr) {
  if (!dateStr) return "";

  // Ép kiểu moment với định dạng đầu vào cụ thể
  const postDate = moment(dateStr, "DD/MM/YYYY HH:mm:ss");
  const now = moment();

  // Tính toán sự khác biệt
  const diffMinutes = now.diff(postDate, "minutes");
  const diffHours = now.diff(postDate, "hours");
  const diffDays = now.diff(postDate, "days");

  // Logic trả về chuỗi thân thiện
  if (diffMinutes < 30) {
    return diffMinutes <= 0 ? "Vừa xong" : `${diffMinutes} phút trước`;
  } else if (diffMinutes >= 30 && diffMinutes < 60) {
    return "nửa giờ trước";
  } else if (diffHours < 24) {
    return `${diffHours} giờ trước`;
  } else {
    return `${diffDays} ngày trước`;
  }
}

export function formatDate(dateString) {
  if (!dateString) {
    return "";
  }

  // Định dạng của chuỗi ĐẦU VÀO (chuỗi bạn nhận được từ data.item.publicationDateShow)
  const inputFormat = "DD/MM/YYYY HH:mm:ss";

  // Định dạng ĐẦU RA MONG MUỐN
  const outputFormat = "DD/MM/YYYY";

  // Sử dụng dayjs để parse chuỗi dựa trên định dạng đầu vào, sau đó format lại
  const formattedDate = dayjs(dateString, inputFormat).format(outputFormat);

  // Kiểm tra tính hợp lệ trước khi trả về
  if (formattedDate === "Invalid Date") {
    return ""; // Trả về rỗng nếu không parse được
  }

  return formattedDate;
}

// --- HÀM NỘI BỘ ---
function _parseAndNormalizeDate(input) {
  const date = new Date(input);
  if (isNaN(date.getTime())) {
    return null; // Trả về null nếu ngày không hợp lệ
  }
  date.setHours(0, 0, 0, 0); // Chuẩn hóa về đầu ngày
  return date;
}

export function getDayNameVietnamese(dayNameEn) {
  const map = {
    Sunday: "Chủ Nhật",
    Monday: "Thứ Hai",
    Tuesday: "Thứ Ba",
    Wednesday: "Thứ Tư",
    Thursday: "Thứ Năm",
    Friday: "Thứ Sáu",
    Saturday: "Thứ Bảy",
  };
  return map[dayNameEn] || dayNameEn;
}

export function getCurrentDay() {
  return new Date();
}

/**
 HÀM NÀY CHECK GIÁ TRỊ LỚN (orEqualTo = false ) còn bằng thì (orEqualTo = true)  \
 VD : birthDate_17 = '2008-09-10' isAgeGreaterThan(birthDate_17, 18, true)); => false
 VD : birthDate_19 = '2006-09-08';isAgeGreaterThan(birthDate_19, 18, true)); => true
 */
export function isAgeGreaterThan(birthDateInput, years, orEqualTo = false) {
  const birthDate = _parseAndNormalizeDate(birthDateInput);
  if (!birthDate) return false; // Ngày sinh không hợp lệ

  // Tính ngày sinh giới hạn. Bất kỳ ai sinh TRƯỚC ngày này đều đáp ứng điều kiện.
  const thresholdDate = new Date();
  thresholdDate.setFullYear(thresholdDate.getFullYear() - years);
  const normalizedThresholdDate = _parseAndNormalizeDate(thresholdDate);

  if (orEqualTo) {
    return birthDate.getTime() <= normalizedThresholdDate.getTime();
  } else {
    return birthDate.getTime() < normalizedThresholdDate.getTime();
  }
}

/*
  HÀM NÀY CHECK GIÁ TRỊ NHỎ HƠN (orEqualTo = false ) còn bằng thì (orEqualTo = true)  \
 */
export function isAgeLessThan(birthDateInput, years, orEqualTo = false) {
  const birthDate = _parseAndNormalizeDate(birthDateInput);
  if (!birthDate) return false; // Ngày sinh không hợp lệ

  // Tính ngày sinh giới hạn. Bất kỳ ai sinh SAU ngày này đều đáp ứng điều kiện.
  const thresholdDate = new Date();
  thresholdDate.setFullYear(thresholdDate.getFullYear() - years);
  const normalizedThresholdDate = _parseAndNormalizeDate(thresholdDate);

  if (orEqualTo) {
    // Tuổi <= years  <==>  Ngày sinh >= ngày giới hạn
    return birthDate.getTime() >= normalizedThresholdDate.getTime();
  } else {
    // Tuổi < years  <==>  Ngày sinh > ngày giới hạn
    return birthDate.getTime() > normalizedThresholdDate.getTime();
  }
}

// --- CÁC HÀM SO SÁNH MỚI ---

/**
 * So sánh xem dateA có SAU dateB hay không.
 * @param {Date|string|number} timeline - Ngày thứ nhất.
 * @param {Date|string|number} dateB - Ngày thứ hai.
 * @param {boolean} [orEqualTo=false] - Nếu true, sẽ so sánh LỚN HƠN HOẶC BẰNG (>=). Mặc định là false (>).
 * @returns {boolean}
 */
export function isDateAfterTimeline(timeline, dateB, orEqualTo = false) {
  const normalizedA = _parseAndNormalizeDate(timeline);
  const normalizedB = _parseAndNormalizeDate(dateB);
  if (!normalizedA || !normalizedB) return false;

  if (orEqualTo) {
    // So sánh LỚN HƠN HOẶC BẰNG (>=)
    return normalizedA.getTime() >= normalizedB.getTime();
  } else {
    // So sánh LỚN HƠN (>)
    return normalizedA.getTime() > normalizedB.getTime();
  }
}

/**
 * So sánh xem dateA có TRƯỚC dateB hay không.
 * @param {Date|string|number} timeline - MỐC SO SÁNH .
 * @param {Date|string|number} dateB - Ngày so sánh.
 * @param {boolean} [orEqualTo=false] - Nếu true, sẽ so sánh NHỎ HƠN HOẶC BẰNG (<=). Mặc định là false (<).
 * @returns {boolean}
 */
export function isDateBeforeTimeline(timeline, dateB, orEqualTo = false) {
  const normalizedA = _parseAndNormalizeDate(timeline);
  const normalizedB = _parseAndNormalizeDate(dateB);
  if (!normalizedA || !normalizedB) return false;

  if (orEqualTo) {
    // So sánh NHỎ HƠN HOẶC BẰNG (<=)
    return normalizedA.getTime() <= normalizedB.getTime();
  } else {
    // So sánh NHỎ HƠN (<)
    return normalizedA.getTime() < normalizedB.getTime();
  }
}

// const dynamicYearRange = computed(() => {
//     const currentYear = new Date().getFullYear();
//
//     // Ví dụ: Cho phép chọn từ 70 năm trước đến năm hiện tại
//     const startYear = currentYear - 100;
//     const endYear = currentYear;
//     return [startYear, endYear];
// });

export function getDynamicRangeYear(range) {
  const currentYear = getCurrentDay().getFullYear();
  const startYear = currentYear - range;
  return [startYear, currentYear];
}

export function subtractYears(yearsToSubtract) {
  const today = new Date();
  today.setFullYear(today.getFullYear() - yearsToSubtract);

  // console.info("LOG SUBRTRAC YEARS ", today)
  return today;
}
// export function subtractYears(yearsToSubtract) {
//     const today = new Date();
//     const year = today.getFullYear() - yearsToSubtract;
//
//     // Trả về ngày 01/01 của năm tính toán
//     return new Date(year, 0, 1);
// }

/**
 * Kiểm tra hai giá trị có cùng năm hay không
 * @param {Date|string} dateA - Ngày cần so sánh
 * @param {Date|string|number} dateB - Ngày hoặc năm
 * @returns {null|Date}
 */
// Chuẩn hóa date từ string hoặc Date object
function _parseDate(value) {
  if (!value) return null;

  if (value instanceof Date && !isNaN(value)) {
    return value;
  }

  // Trường hợp là chuỗi "2025-11-30T17:00:00Z"
  const parsed = new Date(value);
  return isNaN(parsed) ? null : parsed;
}
export function isSameYear(dateA, dateB) {
  const parsedA = _parseDate(dateA);
  if (!parsedA) return false;

  let yearB;

  console.info("LOG isSameYear dateA:", dateA, " dateB", dateB);

  // Nếu truyền trực tiếp là số năm (ví dụ: "2025" hoặc 2025)
  if (typeof dateB === "string" && /^\d{4}$/.test(dateB)) {
    yearB = parseInt(dateB, 10);
  } else if (typeof dateB === "number") {
    yearB = dateB;
  } else {
    const parsedB = _parseDate(dateB);
    if (!parsedB) return false;
    yearB = parsedB.getFullYear();
  }

  return parsedA.getFullYear() === yearB;
}

/**
 * Kiểm tra dateA có lớn hơn dateB ít nhất X năm không
 * @param {Date|string|number} dateA - Ngày cần so sánh
 * @param {Date|string|number} dateB - Ngày gốc
 * @param {number} years - Số năm chênh lệch tối thiểu
 * @param {boolean} [orEqualTo=false] - Cho phép bằng đúng X năm
 * @returns {boolean}
 */
export function isDateAfterWithYears(dateA, dateB, years, orEqualTo = false) {
  const normalizedA = _parseAndNormalizeDate(dateA);
  const normalizedB = _parseAndNormalizeDate(dateB);
  if (!normalizedA || !normalizedB) return false;

  // Tính mốc dateB + X năm
  const compareDate = new Date(normalizedB);
  compareDate.setFullYear(compareDate.getFullYear() + years);

  if (orEqualTo) {
    return normalizedA.getTime() >= compareDate.getTime();
  } else {
    return normalizedA.getTime() > compareDate.getTime();
  }
}
